import { Box } from '@mui/material';

interface SummaryBarProps {
  width: number;
  color: string;
}

export const SummaryBar = ({ width, color }: SummaryBarProps) => {
  const widthPercentage = width > 0 ? `${String(width)}%` : 0;

  const borderStyling = {
    borderRadius: 2,
  };

  if (width === 0) {
    return null;
  }

  return (
    <Box sx={{ backgroundColor: 'action.hover', ...borderStyling }}>
      <Box
        height='12px'
        width={widthPercentage}
        bgcolor={color}
        sx={borderStyling}
      />
    </Box>
  );
};
